import { useEffect, useState } from 'react'
import { useActionData, useNavigation, Form, useSearchParams } from 'react-router-dom';
import Field from '../components/form/Field.jsx'
import Button from '../components/Button.jsx'
import ReactRecaptcha3 from 'react-google-recaptcha3'
import EmailConfirmation from '../components/EmailConfirmation.jsx'
import { SignUpSession } from '../repo/SessionsRepo.js';
import { config } from '../config';

function SignUpPage() {
  const responseData = useActionData()
  const signInNavigation = useNavigation()
  const isSubmitting = signInNavigation.state === 'submitting'
  const [termsChecked, setTermsChecked] = useState(false)
  const [termsError, setTermsError] = useState('')

  function handleSubmit(e) {
    if (!termsChecked) {
      e.preventDefault()
      setTermsError('Você precisa confirmar que leu e entendeu o regulamento, termos de uso e política de privacidade')
    } else {
      const expires = new Date()
      expires.setFullYear(expires.getFullYear() + 1)
      document.cookie = `cookie_consent=accepted; expires=${expires.toUTCString()}; domain=.bolaodacopa.com; path=/`

      setTermsError('')
    }
  }

  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('token') || null
  const inviteGroupID = searchParams.get('group_id') || null

  useEffect(() => {
    ReactRecaptcha3.init(config.recaptchaPublicKey).then(status => {
      if (status !== 'success') {
        console.log("Error! Could not load Recaptcha.")
      }
    })
  }, [])

  function successResponse(respData) {
    return (respData && respData.success)
  }

  function nameHasError(respData) {
    if (respData && respData.errors && respData.errors.name) {
      return "Nome inválido!"
    }

    return ""
  }

  function emailHasError(respData) {
    if (respData && respData.errors && respData.errors.email) {
      if (respData.errors.email[0] === "must be unique") {
        return "Já foi cadastrado!"
      } else {
        return "Formato inválido!"
      }
    }

    return ""
  }

  function passwordHasError(respData) {
    if (respData && respData.errors && respData.errors.password) {
      return "Mínimo de 8 caracteres com uma letra maíscula, uma minuscula, um número e um caractere especial"
    }

    return ""
  }

  function passwordConfirmationHasError(respData) {
    if (respData && respData.errors && respData.errors.detail === 'password and confirmation password are different') {
      return "Senha e senha de confirmação são diferentes"
    }

    return ""
  }

  return(
    <section>
      {!successResponse(responseData) && (
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <h1 className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
          Cadastrar
        </h1>
        <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <Form method="POST" className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
              <Field type={"input"} name={"name"} id={"name"} label={"Nome"} required={""} maxLength={50} disabled={isSubmitting} error={nameHasError(responseData)}/>
              <Field type={"email"} name={"email"} id={"email"} label={"Email"} required={""} disabled={isSubmitting} error={emailHasError(responseData)}/>
              <Field type={"password"} name={"password"} id={"password"} label={"Senha"} required={""} disabled={isSubmitting} error={passwordHasError(responseData)}/>
              <Field type={"password"} name={"password_confirmation"} id={"password_confirmation"} label={"Confirme a senha"} required={""} disabled={isSubmitting} error={passwordConfirmationHasError(responseData)}/>
              {inviteToken && (
                <Field type={"hidden"} name={"invite_token"} id={"invite_token"} value={inviteToken}/>
              )}
              {inviteGroupID && (
                <Field type={"hidden"} name={"invite_group_id"} id={"invite_group_id"} value={inviteGroupID}/>
              )}

              <div className="flex items-start gap-2">
                <input
                  type="checkbox"
                  id="terms"
                  checked={termsChecked}
                  onChange={e => setTermsChecked(e.target.checked)}
                  className="mt-1 h-4 w-4 shrink-0 cursor-pointer"
                />
                <label htmlFor="terms" className="text-sm text-gray-700 leading-snug">
                  Li e entendi o{' '}
                  <a href="https://bolaodacopa.com/regulamento/index.html" target="_blank" rel="noreferrer" className="underline text-green-600">regulamento</a>
                  {', '}
                  <a href="https://bolaodacopa.com/termos-de-uso/index.html" target="_blank" rel="noreferrer" className="underline text-green-600">termos de uso</a>
                  {' e '}
                  <a href="https://bolaodacopa.com/politica-de-privacidade/index.html" target="_blank" rel="noreferrer" className="underline text-green-600">política de privacidade</a>
                  {' do Bolão da Copa'}
                </label>
              </div>
              {termsError && (
                <p className="text-red-600 text-sm">{termsError}</p>
              )}

              <Button styleName="green" className="w-full" disabled={isSubmitting} >
                {isSubmitting ? 'Cadastrando...' : 'Cadastrar'}
              </Button>
            </Form>
          </div>
        </div>
      </div>)}
      {successResponse(responseData) && (<EmailConfirmation/>)}
    </section>
  )
}

export default SignUpPage

async function getRecaptchaToken() {
  let recaptchaToken = '';

  await ReactRecaptcha3.getToken().then(token => {
    recaptchaToken = token
  }, error => {
    console.log("ERROR!", error)
  })

  return recaptchaToken;
}

export async function action({request}) {
  const data = await request.formData()

  if (data.get('password') !== data.get('password_confirmation')) {
    return { errors: { detail: 'password and confirmation password are different' } }
  }

  const recaptchaToken = await getRecaptchaToken()

  const signUpData = {
    user: {
      name: data.get('name').substring(0, 50),
      email: data.get('email'),
      password: data.get('password')
    },
    captcha_token: recaptchaToken,
    invite: {}
  }

  if (data.get('invite_token')) {
    signUpData['invite']['token'] = data.get('invite_token')
  }

  if (data.get('invite_group_id')) {
    signUpData['invite']['group_id'] = data.get('invite_group_id')
  }

  const response = await SignUpSession(signUpData)

  if (response.status === 400 || response.status === 423 || response.status === 422) {
    return response.data
  }

  return { success: 'OK' }
}
